import Model, { attr } from '@ember-data/model';

import { buildValidations, validator } from 'ember-cp-validations';

const Validations = buildValidations({
  token: validator('presence', {
    presence: true,
    ignoreBlank: false,
  }),
});
export default class PaymentLinkSessionModel extends Model.extend(Validations) {
  @attr() meta;
  @attr() token;
  @attr() clientId;
  @attr() practiceId;
  @attr() paymentLinkUuid;
  @attr() expiresAt;
}
